import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function AdminRoute({ children }) {
  const { user, initializing } = useAuth();
  if (initializing) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-sm text-muted-foreground font-serif italic">Загрузка…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (!["owner", "administrator", "curator"].includes(user.role)) return <Navigate to="/" replace />;
  return children;
}
